import { Component, OnInit } from '@angular/core';
import { Globals } from '../../_models/globals';
import { ApiIntegration } from '../../_services/api.integration';
import { Router, ActivatedRoute } from '@angular/router';
import { User } from '../../_models/user';
import { AlertService } from '../../_services/alert.service';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';

@Component({
  selector: 'app-security-types',
  templateUrl: './security-types.component.html',
  styleUrls: ['./security-types.component.css']
})
export class SecurityTypesComponent implements OnInit {
  group: any = {
    groupCode: "",
    groupDescription: "",
  };
  getSecurityTypes: any = [];
  groupActive: any;
  groups: any = [];

  securityType: string;
  securityName: string;
  dependentOn: string;
  accessType: string;

  securityCodeError: string;
  securityNameError: string;
  dependentError: string;
  accessTypeError: string;

  constructor(private http: HttpClient, private router: Router, private route: ActivatedRoute, private g: Globals, private api: ApiIntegration, public user: User, private alertService: AlertService) {
    this.g.page = "Security Types";
    this.getGroupFunction();
    this.api.getGroup(this.route.snapshot.params['name'], this.route.snapshot.params['id']).subscribe((data: any) => { this.groupActive = data; }, err => { console.log(err); });
    this.api.getValues("1", "SECURITY_ACCESS_TYPE", "ACCESS_TYPE", "Access Type").subscribe((data: any) => { this.getSecurityTypes = data.tripleSetConfigDTOS; }, err => {
      this.alertService.error('Error', err);
    });
  }
  getGroupFunction() {
    this.g.loaderDisplay = "display";
    this.api.getGroup(this.route.snapshot.params['name'], this.route.snapshot.params['id']).subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.group = data;
    }, err => {
      this.g.loaderDisplay = "";
      console.log(err);
    });
  }
  ngOnInit() {
  }
  typeCode() {
    this.securityCodeError = "";
    if (this.securityType == '' || this.securityType === null || this.securityType === undefined || this.securityType === 'undefined') {
      this.securityCodeError = 'Please enter Security Type';
    }
  }
  typeName() {
    this.securityNameError = "";
    if (this.securityName == '' || this.securityName === null || this.securityName === undefined || this.securityName === 'undefined') {
      this.securityNameError = 'Please enter Security Name';
    }
  }
  typeAccess() {
    this.accessTypeError = "";
    if (this.accessType == '' || this.accessType === null || this.accessType === undefined || this.accessType === 'undefined') {
      this.accessTypeError = 'Please Select accessType';
    }
  }

  submitSecurity() {
    this.securityCodeError = "";
    this.securityNameError = "";
    this.accessTypeError = "";

    if (this.securityType == '' || this.securityType === null || this.securityType === undefined || this.securityType === 'undefined') {
      this.securityCodeError = 'Please enter Security Type';
    }
    if (this.securityName == '' || this.securityName === null || this.securityName === undefined || this.securityName === 'undefined') {
      this.securityNameError = 'Please enter Security Name';
    }
    if (this.accessType == '' || this.accessType === null || this.accessType === undefined || this.accessType === 'undefined') {
      this.accessTypeError = 'Please Select accessType';
    }

    if (this.securityCodeError != "" || this.securityNameError != "" || this.accessTypeError != "") {
      this.g.loaderDisplay = "";
      return false;
    }
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/createAppSecurityType', {
      "status": "ACTIVE",
      "accessType": this.accessType,
      "dependentOn": this.dependentOn,
      "groupDescription": this.group.groupDescription,
      "groupCode": this.group.groupCode,
      "securityCode": this.securityType,
      "securityName": this.securityName,
      "level": ""
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Security Type', 'Submitted Successfully');
          this.securityType = "";
          this.securityName = "";
          this.dependentOn = "";
          this.accessType = "";
          this.getGroupFunction();
        }
        else {
          this.alertService.error('Error', data['message']);
        }
        this.g.loaderDisplay = "";
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

  changeStatus(n) {
    this.g.loaderDisplay = "display";
    if (n.status == "ACTIVE") {
      n.status = "IN_ACTIVE";
    } else {
      n.status = "ACTIVE";
    }
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateSecurityTypeStatus', {
      "securityStatus": n.status,
      "securityTypeId": n.securityTypeId
    }, { headers: header1 }).subscribe(data => {
      this.g.loaderDisplay = "";
      if (data['code'] == 200) {
        this.alertService.success('Security Type', 'Status Updated Successfully');

      } else {
        this.alertService.error('Error', data['message']);
      }
      this.g.loaderDisplay = "";
    },
      (err: HttpErrorResponse) => {

        this.g.loaderDisplay = "";
      });

  }

}
